/* ==========================================================================
   Timo Wolfinger – Wunschliste

   Speicherung in localStorage, kein Kundenkonto noetig. Jeder Zugriff auf
   localStorage laeuft durch try/catch: im privaten Modus oder bei gesperrtem
   Speicher faellt die Wunschliste still auf "leer" zurueck, statt die Seite
   zu zerlegen.

   Die Karten der Wunschlistenansicht werden aus /products/<handle>.js gebaut
   und spiegeln die Logik aus snippets/tw-card, tw-brand, tw-name und tw-money.
   ========================================================================== */
(function () {
  'use strict';

  var KEY = 'tw:wishlist';

  /* ---------- Speicher ---------- */
  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      if (!raw) return [];
      var v = JSON.parse(raw);
      if (!Array.isArray(v)) return [];
      return v.filter(function (x) { return typeof x === 'string' && x.length; });
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list));
      return true;
    } catch (e) {
      return false;
    }
  }

  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    if (i > -1) { list.splice(i, 1); } else { list.unshift(handle); }
    write(list);
    return list.indexOf(handle) > -1;
  }

  /* ---------- Darstellung ---------- */
  function euro(cents) {
    return (cents / 100).toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + ' €';
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function brandAndName(p, houses) {
    var t = String(p.title || '').trim();
    if (t.slice(-1) === '.') t = t.slice(0, -1);

    var vendor = String(p.vendor || '').trim();
    var vendorKey = vendor.toLowerCase().replace(/\s+/g, '');
    var vendorOk = vendor.length > 0 && vendorKey.indexOf('meinshop') === -1;

    var idx = t.indexOf(': ');
    var prefix = idx > -1 ? t.slice(0, idx).trim() : '';

    var brand = vendorOk ? vendor : prefix;
    var name = t;

    if (prefix) {
      var strip = (prefix === vendor) || houses.indexOf(prefix) > -1 || !vendorOk;
      if (strip) name = t.slice(idx + 2).trim();
    }
    return { brand: brand, name: name };
  }

  /* Flakonpreis: 2-ml-Proben aus der Spanne ausklammern. */
  function priceInfo(p) {
    var sample = null, min = null, max = null;
    var vs = p.variants || [];
    for (var i = 0; i < vs.length; i++) {
      var v = vs[i];
      var opts = [v.option1, v.option2, v.option3];
      var isSample = false;
      for (var k = 0; k < opts.length; k++) {
        if (opts[k] && String(opts[k]).toUpperCase().replace(/\s+/g, '') === '2ML') isSample = true;
      }
      if (isSample) { sample = v.price; continue; }
      if (min === null || v.price < min) min = v.price;
      if (max === null || v.price > max) max = v.price;
    }
    if (min === null) { min = p.price_min; max = p.price_max; }
    return { min: min, max: max, sample: sample };
  }

  function cardHTML(p, houses) {
    var bn = brandAndName(p, houses);
    var pi = priceInfo(p);
    var url = p.url || ('/products/' + p.handle);
    var img = p.featured_image || (p.images && p.images[0]);

    var priceHTML = pi.min < pi.max
      ? 'ab ' + euro(pi.min)
      : euro(pi.min);

    var cta;
    if (!p.available) {
      cta = '<span class="tw-card__cta" aria-disabled="true">Ausverkauft</span>';
    } else if ((p.variants || []).length === 1) {
      /* Nur eine Variante: direkt in den Warenkorb. */
      cta = '<form method="post" action="/cart/add">' +
        '<input type="hidden" name="form_type" value="product">' +
        '<input type="hidden" name="utf8" value="✓">' +
        '<input type="hidden" name="id" value="' + p.variants[0].id + '">' +
        '<input type="hidden" name="quantity" value="1">' +
        '<button type="submit" class="tw-card__cta">In den Warenkorb</button></form>';
    } else {
      /* Konfigurierbare Produkte (Adelsband Signature, Imperial, Duefte mit
         Groessen) fuehren bewusst auf die Produktseite. */
      cta = '<a class="tw-card__cta" href="' + esc(url) + '">Auswählen</a>';
    }

    return '<div class="tw-card">' +
      '<a class="tw-card__img" href="' + esc(url) + '" aria-label="' + esc(bn.name) + '">' +
        (img ? '<img src="' + esc(img) + '" alt="' + esc(bn.name) + '" loading="lazy">' : '') +
        (p.available ? '' : '<span class="tw-card__badge tw-card__badge--out">Ausverkauft</span>') +
      '</a>' +
      '<button type="button" class="tw-wish is-on" data-tw-wish="' + esc(p.handle) + '"' +
        ' aria-pressed="true"' +
        ' data-label-on="' + esc(bn.name) + ' von der Wunschliste entfernen"' +
        ' data-label-off="' + esc(bn.name) + ' auf die Wunschliste setzen"' +
        ' aria-label="' + esc(bn.name) + ' von der Wunschliste entfernen">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5S3.5 15 3.5 9.2A4.7 4.7 0 0 1 12 6.4a4.7 4.7 0 0 1 8.5 2.8c0 5.8-8.5 11.3-8.5 11.3z"/></svg>' +
      '</button>' +
      (bn.brand ? '<p class="tw-card__brand">' + esc(bn.brand) + '</p>' : '') +
      '<h3><a href="' + esc(url) + '">' + esc(bn.name) + '</a></h3>' +
      (p.type ? '<p class="tw-card__sub">' + esc(p.type) + '</p>' : '') +
      '<p class="tw-card__price">' + priceHTML + '</p>' +
      (pi.sample !== null ? '<p class="tw-card__hint">Auch als 2-ml-Probe · ' + euro(pi.sample) + '</p>' : '') +
      cta +
    '</div>';
  }

  /* ---------- Synchronisierung der Bedienelemente ---------- */
  function syncCount() {
    var n = read().length;
    var nodes = document.querySelectorAll('[data-tw-wish-count]');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].textContent = n;
      nodes[i].hidden = n === 0;
    }
  }

  function syncButtons() {
    var list = read();
    var nodes = document.querySelectorAll('[data-tw-wish]');
    for (var i = 0; i < nodes.length; i++) {
      var b = nodes[i];
      var on = list.indexOf(b.getAttribute('data-tw-wish')) > -1;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.classList.toggle('is-on', on);
      var lbl = b.getAttribute(on ? 'data-label-on' : 'data-label-off');
      if (lbl) {
        b.setAttribute('aria-label', lbl);
        var t = b.querySelector('[data-tw-wish-text]');
        if (t) t.textContent = on ? (b.getAttribute('data-text-on') || lbl) : (b.getAttribute('data-text-off') || lbl);
      }
    }
  }

  /* ---------- Wunschlistenansicht ---------- */
  function renderView(root) {
    var houses = String(root.getAttribute('data-houses') || '')
      .split(',').map(function (s) { return s.trim(); }).filter(Boolean);

    var grid = root.querySelector('[data-tw-wish-grid]');
    var empty = root.querySelector('[data-tw-wish-empty]');
    var count = root.querySelector('[data-tw-wish-total]');
    var handles = read();

    if (!handles.length) {
      grid.innerHTML = '';
      grid.hidden = true;
      empty.hidden = false;
      if (count) count.hidden = true;
      return;
    }

    Promise.all(handles.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (items) {
      /* Geloeschte oder nicht mehr veroeffentlichte Produkte aus dem Speicher werfen. */
      var alive = [];
      for (var i = 0; i < items.length; i++) {
        if (items[i]) alive.push(handles[i]);
      }
      if (alive.length !== handles.length) write(alive);

      var good = items.filter(Boolean);
      if (!good.length) {
        grid.innerHTML = '';
        grid.hidden = true;
        empty.hidden = false;
        if (count) count.hidden = true;
        syncCount();
        return;
      }

      grid.innerHTML = good.map(function (p) { return cardHTML(p, houses); }).join('');
      grid.hidden = false;
      empty.hidden = true;
      if (count) {
        count.textContent = good.length + (good.length === 1 ? ' Produkt gemerkt' : ' Produkte gemerkt');
        count.hidden = false;
      }
      syncCount();
    });
  }

  function renderViews() {
    var roots = document.querySelectorAll('[data-tw-wish-view]');
    for (var i = 0; i < roots.length; i++) renderView(roots[i]);
  }

  /* ---------- Ereignisse ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-tw-wish]') : null;
    if (!b) return;
    /* Verhindert, dass der Klick auf das Herz die Produktseite oeffnet. */
    e.preventDefault();
    e.stopPropagation();
    toggle(b.getAttribute('data-tw-wish'));
    syncButtons();
    syncCount();
    document.dispatchEvent(new CustomEvent('tw:wishlist:change'));
  });

  document.addEventListener('tw:wishlist:change', renderViews);

  /* Aenderung in einem anderen Tab uebernehmen. */
  window.addEventListener('storage', function (e) {
    if (e.key !== KEY) return;
    syncButtons();
    syncCount();
    renderViews();
  });

  function init() {
    syncButtons();
    syncCount();
    renderViews();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
